import React, { Component } from 'react';
import { Row, Radio, Spin, Icon, Tooltip, Col, Select } from 'antd';
import { openNotification } from '../../util/notificaciones';
import CategoriasRequest from '../../services/Categorias';
import PedidosRequest from '../../services/Pedidos';
import ResponsiveCard from '../Common/ResponsiveCard';

const { Option } = Select;

/**
 * Clase para ver el proceso de modelo de pedido
 */
export default class CategoriaPedido extends Component {
    state = {
        arrCategorias: [],
        categoriaSelected: null,
        categoriaSelectedName: null,
        disableBtnContinuar: true,
        cargando: false,
        segmentoNumero: null,
        categoriaBloqueada: null,
        tiempoRestante: null,
        sitios:[],
        sitioPedidoSelected:null
    }

    /**
     * Función que se ejecuta cuando se cargan los datos
     */
    componentDidMount = () => {
        let state = { ...this.state }

        this.setState({ cargando: true }, () => {
            CategoriasRequest.ListarCategorias()
                .then(response => {
                    state.arrCategorias = response.data
                    state.cargando = false
                    return PedidosRequest.ListarSitiosSupervisor();
                }).then(response => {
                    state.sitios = response.data.sitio;
                    state.segmentoNumero = response.data.segmento_numero;
                    this.setState(state);
                })
                .catch(err => {
                    openNotification(
                        "Ha ocurrido un error al cargar las categorías.",
                        "Error al cargar categorías",
                        false
                    )
                })
        })
    }

    /**
     * Función que se cambia la categoría
     * @param: value. valor del id de la categoría
     * @return: nada.
     */
    onChangeCategoria = (value) => {
        let state = { ...this.state }
        state.categoriaSelected = value.target.value;
        state.categoriaSelectedId = value.target.value;
        state.disableBtnContinuar = false;

        for (let index = 0; index < state.arrCategorias.length; index++) {
            const element = state.arrCategorias[index];
            if (value.target.value === element.id) state.categoriaSelectedName = element.descripcion
        }

        let categoriaSelected = state.categoriaSelectedName;
        let categoriaSelectedId = state.categoriaSelected;
        let segmentoNumero = state.segmentoNumero;
        let drive_id = state.sitioPedidoSelected;
        
        // Guardar ruta anterior y parámetros en localStorage
        localStorage.setItem("previousPath", this.props.history.location.pathname);
        
        if (categoriaSelected === 'Auxiliares')
        {
            this.props.history.push(
                {
                    pathname: `/pedido/auxiliar`,
                    state: {
                        categoria_id: categoriaSelectedId,
                        categoria: categoriaSelected,
                        segmento_numero: segmentoNumero,
                        drive_id: drive_id
                    }
                }
            )   
        }
        else {
            this.props.history.push(
                {
                    pathname: `/generar/pedido`,
                    state: {
                        categoria_id: categoriaSelectedId,
                        categoria: categoriaSelected,
                        segmento_numero: segmentoNumero,
                        drive_id: drive_id
                    }
                }
            )
        }

        this.setState(state)
    }

    /**
     * Función que se cambia la región
     * @param: value. valor del id de la región
     * @return: nada.
     */
    handleChangeSitio = (value) => {
        let state = { ...this.state }
        state.sitioPedidoSelected= null;

        if (value === undefined)
        {
            state.sitioPedidoSelected = null;
        }
        else {
            state.sitioPedidoSelected = value;
        }

        this.setState(state);
    }

    render() {
        const sitioRequerido = ["Auditor", "Asesor"].includes(
            localStorage.getItem("role")
        );

        const bloquearCategorias = sitioRequerido && !this.state.sitioPedidoSelected
 
        return (
            <ResponsiveCard id="ParentSize"
                title="Módulo generar pedido"
            >
                <div className="panel-block">
                    <div style={{ marginBottom: "20px" }}>
                        <Spin
                            tip="Cargando..."
                            indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                            spinning={this.state.cargando}
                            style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}
                        >
                            {(["Auditor", "Asesor"].includes(localStorage.getItem("role"))) &&   <Row>
                                <Col>
                                    <div>
                                        <span style={{ fontSize: '20px', marginLeft: '30px' }}>Seleccione el sitio</span>
                                    </div>
                                    <Tooltip placement="top" title="Seleccione un sitio cliente">
                                        <Select
                                            id="select-sitios-categoria-modulo"
                                            showSearch
                                            autoFocus={true}
                                            style={{ width: "36%", marginLeft: '30px' }}
                                            defaultActiveFirstOption={false}
                                            notFoundContent='No hay opciones'
                                            placeholder="Seleccionar..."
                                            optionFilterProp="children"
                                            onChange={this.handleChangeSitio}
                                            value={this.state.sitioPedidoSelected}
                                        >
                                            <Option key={null} disabled={true}>Seleccionar...</Option>
                                            {
                                                this.state.sitios.length > 0 &&
                                                this.state.sitios.map((obj, index) => {
                                                    return (
                                                        <Option
                                                            key={obj.id}
                                                            value={obj.id}>
                                                            {obj.nombre}
                                                        </Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </Tooltip>
                                </Col>
                            </Row>}
                            <Row>
                                <span style={{ fontSize: '20px', marginLeft: '30px' }}>Seleccione categoría</span>
                            </Row> <br />
                            <Row gutter={24}>
                                <Radio.Group
                                    onChange={this.onChangeCategoria}
                                    buttonStyle="solid"
                                    disabled={bloquearCategorias}
                                >
                                {this.state.arrCategorias.length > 0 &&
                                    this.state.arrCategorias.map(obj => (
                                        <Tooltip
                                            key={obj.id}
                                            placement="top"
                                            title={ obj.descripcion }
                                        >
                                            <Radio.Button
                                                className="radio-button radio-center"
                                                value={obj.id}
                                            >
                                                {obj.descripcion}
                                            </Radio.Button>
                                        </Tooltip>
                                    ))}
                                </Radio.Group>
                            </Row>
                        </Spin>
                    </div>
                </div>
            </ResponsiveCard>
        )
    }
}